<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>APPOINTMENTS</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="appointment-info">
        <ng-container *ngIf="appointments; else listLoading">
            <ng-container *ngIf="appointments.length; else noResults">
                <ng-container *ngFor="let group of appointments">
                    <div class="list-header">
                        {{ group.date | date: 'longDate' }}
                    </div>
                    <mat-list class="full-width">
                        <mat-list-item *ngFor="let appointment of group.appointments"
                            (click)="loadAppointment(appointment)" class="auto-height">
                            <div class="appointment-item">
                                <div class="appointment-details">

                                    <div matLine class="appointment-title">
                                        <span>{{ appointment.date | date: 'longDate'}} at {{
                                            (appointment.date.toString().substring(0,10) + 'T' + appointment.timeSlot) |
                                            date:
                                            'HH:mm'}}{{appointment.endSlot ? ' - ' + appointment.endSlot : ''}}
                                            {{appointment.appointmentType}}</span>
                                        <span class="confirmed-chip" *ngIf="appointment.confirmedAt"
                                            [matTooltip]="confirmationTooltip(appointment)">
                                            <mat-icon>event_available</mat-icon>Confirmed</span>
                                    </div>

                                    <div matLine class="appointment-footer">
                                        <div>Created By: {{ appointment.createdBy }} at {{ appointment.createdAt | date
                                            :
                                            'HH:mm'}}</div>
                                        <div *ngIf="appointment.updatedAt > appointment.createdAt">
                                            Edited {{ appointment.updatedAt | dateDiff }} ago
                                        </div>
                                    </div>
                                    <div matLine class="appointment-footer">
                                        <div>{{getReminderMessage(appointment)}}</div>
                                    </div>
                                    <div class="appointment-status" matTooltip="{{ 
                                        appointment.isCancelled === true ? 'Appointment cancelled' :
                                        appointment.didNotAttend === true ? 'Patient did not attend' :
                                        appointment.patientArrivedTime == null && appointment.startTime == null && appointment.endTime == null ? 'No activity yet' :
                                        appointment.patientArrivedTime !== null && appointment.endTime == null ? 'This patient has arrived' :
                                        appointment.startTime !== null && appointment.endTime === null ? 'Appointment in progress' :
                                        appointment.endTime !== null && appointment.noteSaved === false ? 'Appointment completed. Note not saved to timeline' : 
                                        appointment.endTime !== null && appointment.noteSaved === true ? 'Appointment completed. Note saved to timeline' : ''
                                    }}" [class.default]="appointment.patientArrivedTime == null && appointment.startTime == null && appointment.endTime == null && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.arrived]="appointment.patientArrivedTime !== null && appointment.endTime == null && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.busy]="((appointment.startTime !== null && appointment.endTime === null) || (appointment.endTime !== null && appointment.noteSaved === false)) && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.completed]="((appointment.endTime !== null && appointment.noteSaved == null) || appointment.noteSaved) && appointment.isCancelled !== true && appointment.didNotAttend !== true"
                                        [class.cancelled]="appointment.isCancelled === true"
                                        [class.did-not-attend]="appointment.didNotAttend === true">
                                    </div>
                                </div>
                                <div class="view-icon">
                                    <button *ngIf="canSendReminder(appointment.date)" mat-icon-button
                                        matTooltip="Send a reminder email"
                                        (click)="sendReminderEmail($event, appointment)">
                                        <mat-icon>mail</mat-icon>
                                    </button>
                                    <button mat-icon-button matTooltip="Edit this appointment">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </mat-list-item>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>